import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-081894e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-card card-user" }
const _hoisted_2 = { class: "list-card__main-field" }
const _hoisted_3 = { class: "list-card__avatar-field" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "list-card__content-field" }
const _hoisted_6 = { class: "list-card__top-field" }
const _hoisted_7 = { class: "card-user__user-name text-primary" }
const _hoisted_8 = { class: "list-card__middle-field" }
const _hoisted_9 = { class: "card-user__user-signature" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "avatar",
          src: _ctx.processAvatar(_ctx.user.avatar)
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.user.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.user.bio), 1)
        ])
      ])
    ])
  ]))
}